import { render, staticRenderFns } from "./ModalContentAddReminder.vue?vue&type=template&id=6b068f4a&scoped=true&"
import script from "./ModalContentAddReminder.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddReminder.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddReminder.vue?vue&type=style&index=0&id=6b068f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b068f4a",
  null
  
)

export default component.exports